module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leader-board"
  }, [(!_vm.user) ? _c('div', {
    staticClass: "loader"
  }, [_c('p', {
    staticStyle: {
      "margin": "40px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("leaderBoard.leaderBoard.register-only")) + "\n    ")]), _vm._v(" "), _c('LoginButton', {
    staticClass: "googleBtn"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.leaderboard) ? _c('div', {
    staticClass: "loader"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("leaderBoard.leaderBoard.loading")) + "\n    "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center",
      "margin": "8px"
    }
  }, [_c('SlinkyVue')], 1)]) : _vm._e(), _vm._v(" "), (_vm.newList) ? _c('div', {
    staticClass: "top-users"
  }, _vm._l((_vm.newList), function(ruser, idx) {
    return _c('div', {
      key: idx,
      staticClass: "user",
      class: {
        divMe: _vm.userProfileNum == ruser.id
      }
    }, [_c('div', {
      staticClass: "idx rankSqure"
    }, [_vm._v(_vm._s(ruser.num))]), _vm._v(" "), _c('div', {
      staticClass: "laws rankSqure"
    }, [_vm._v(_vm._s(ruser.words_score))]), _vm._v(" "), _c('div', {
      staticClass: "words rankSqure"
    }, [_vm._v(_vm._s(ruser.rules_score / 5))]), _vm._v(" "), _c('div', {
      staticClass: "sentance rankSqure"
    }, [_vm._v(_vm._s(ruser.sentences_score / 10))])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c06d47f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeaderBoard/LeaderBoard.vue
// module id = 342
// module chunks = 0 13